import http from 'common-module/src/util/http';

/**
 * 获取新手引导当前完成的步骤
 * @param {*} data
 * @returns
 */
export async function getGuideStep(data) {
  return http.post('/account-preferences/get-guide-step', data);
}

/**
 * 获取可选的用户角色
 * @param {*} data
 * @returns
 */
export async function getAllRoles(data) {
  return http.post('/account-preferences/get-user-role-preference', data);
}

/**
 * 保存用户选择的角色 --海外版
 * @param {*} data
 * @returns
 */
export async function saveAccountRole(data) {
  return http.post('/account-preferences/save-account-role', data);
}

/**
 * 获取用户可选的插件 --海外版
 * @param {*} data
 * @returns
 */
export async function getUserPluginPreference(data) {
  return http.post('/account-preferences/get-user-plugin-preference', data);
}

/**
 * 保存用戶選擇的插件 --海外版
 * @param {*} data
 * @returns
 */
export async function saveUserPluginPreference(data) {
  return http.post('/account-preferences/save-account-plugin', data);
}

/**
 * 功能導覽獲取推薦 --海外版
 * @param {*} data
 * @returns
 */
export async function getGuideRecommend(data) {
  return http.post('/account-preferences/get-guide-instance', data);
}

/**
 * 記錄用戶指引步驟
 * @param {*} step
 * @returns
 */
export async function guideRecord(step) {
  return http.post('/account/guide-record', { guideType: step });
}

// 试用指定版本的产品权益
export async function setProduceTrial(schemeType) {
  return http.post('/product-right/trial', { schemeType });
}

/**
 *
 * @param {*} schemeType
 * @returns 獲取價格版本列表
 */
export async function getProductSchemes(data = {}) {
  return http.post('/product-scheme/product-schemes', data);
}

/**
 * 更新任务状态
 * @param {*} data
 * @returns
 */
export async function updateGuideTask(data) {
  return http.get('/quest/update-status', data);
}

/**
 * 获取项目迭代数据
 * @param {*} data
 * @returns
 */
export async function getSprintList(data) {
  return http.post('/sprint/list-with-count-page', data);
}

/* 根据目标选择初始化工作台 */
export async function initHomeWidget(targetChoice) {
  return http.post('/sys-home/init-home-widget', { targetChoice, reportProject:true });
}


/* 新手引导获取第一步问题 */
export async function getFirstStepQuestion() {
  return http.post('account-preferences/get-first-step-question', {});
}

/* 新手引导保存第一步问题 */
export async function saveFirstStepQuestion(data) {
  return http.post('/account-preferences/save-first-step-question', data);
}

export async function getAccountPlugins(data = {}) {
  return http.post('/account-preferences/get-tenant-plugin', data);
}

export async function updateDemoFigmaSwitch(enabled, timestamp = new Date().getTime()) {
  return http.post(`/account-preferences/demo-figma-change/${timestamp}`, { enabled });
}